import ProductHighlightsProvider from './hooks/useProductHighlights';

import { ProductHighlightsProps } from './@types/ProductHighlightsProps';

const ProductHighlights = (props: ProductHighlightsProps) => (
	<ProductHighlightsProvider {...props}>{props.children}</ProductHighlightsProvider>
);

export default ProductHighlights;
